import { useSelector } from 'react-redux';

import { SCREENING_DATES_REQUIRED_STATE } from '../constants';

import type { RootState } from '../../../../../../../store';

export default function useAreScreeningDatesRequired() {
  return useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.intakeQuestionnaireDetails?.general_info
        ?.client_street_address_state === SCREENING_DATES_REQUIRED_STATE,
  );
}
